module.exports = __webpack_public_path__ + "img/Rowing.6c650592.png";